import { useTranslation } from 'react-i18next';
import { FieldErrors } from 'react-hook-form';

import { InputWrapper } from '@/components/Container/AuthContainer/styles';
import { Text } from '@/components/UI/Typography/Text';
import { pblServiceAreas } from '@/data/pbl';
import { Flex } from '@/layout';

import type { UpdateVolunteerForm, VolunteerFormState } from '../types';
import { FormPanel, FormSectionTitle, SectionTitle, ValidationText } from '../styles';
import { ToggleGroup } from '../shared';

interface Props {
  form: VolunteerFormState;
  errors: FieldErrors<VolunteerFormState>;
  isTablet: boolean;
  updateForm: UpdateVolunteerForm;
}

const ServiceAreasStep = ({ form, errors, isTablet, updateForm }: Props) => {
  //   @ts-ignore
  const { t } = useTranslation();
  const titleWithNumber = t('pbl.lawyerRegistration.serviceAreas.titleWithNumber', {
    defaultValue: '9. Pro Bono Legal Service Areas',
  });

  return (
    <FormPanel isTablet={isTablet}>
      <SectionTitle>{t('pbl.lawyerRegistration.serviceAreas.section', { defaultValue: 'Section 3' })}</SectionTitle>
      <Flex gridGap={'5px'}>
        9. <FormSectionTitle>{titleWithNumber.replace(/^9\.\s*/, '')}</FormSectionTitle>
      </Flex>
      <InputWrapper marginBottom={30}>
        <Text>
          {t('pbl.lawyerRegistration.serviceAreas.intro', {
            defaultValue:
              'FreelegalLink will offer pro bono legal services relating to the following areas to the public. Please select the areas that you would like to assist and have pre-requisite experience in (you may select more than one area):',
          })}
        </Text>
      </InputWrapper>
      <InputWrapper marginBottom={8}>
        <Text>
          {t('pbl.lawyerRegistration.serviceAreas.selectApplicableAreas', {
            defaultValue: 'Select applicable areas *',
          })}
        </Text>
      </InputWrapper>
      <ToggleGroup
        name="service_areas"
        options={pblServiceAreas.map((area) => ({
          value: area.value,
          label: t(area.labelKey as any, { defaultValue: area.defaultLabel }) as string,
        }))}
        values={form.service_areas}
        onChange={(value) => updateForm('service_areas', value)}
      />
      {errors.service_areas?.message && <ValidationText>{errors.service_areas.message}</ValidationText>}
      <InputWrapper marginTop={30}>
        <Text>
          {t('pbl.lawyerRegistration.serviceAreas.scopeNote', {
            defaultValue:
              '10. The above-mentioned pro bono legal service includes up to 45 minutes of free oral legal advice provided via the DMP platform, and may also include document review, document drafting, and legal provision explanation if considered necessary, but does not include court appearance or representation on behalf of the enquirer.',
          })}
        </Text>
      </InputWrapper>
    </FormPanel>
  );
};

export default ServiceAreasStep;
